import { type PropsWithChildren } from 'react';

import {
  Button,
  Card,
  List } from
'~/components/OddscheckerPlus/components/cxy';
import { useTrackCTAImpression } from '~/hooks/use-track-cta-impression';
import {
  SUBSCRIPTION_TERM,
  type SubscriptionTerm } from
'~/utils/getSubscriptionTerm';

import styles from './styles/PriceCard.module.css';

export function PriceCard({
  list,
  onClick,
  price,
  priceFormatted,
  subtitle,
  term,
  title,
  userHasCancelledSubscription,
  ...props









}: {list: string[];onClick?: () => void;price: number;priceFormatted: string;subtitle?: string;term: SubscriptionTerm;title: string;userHasCancelledSubscription: boolean;} & PropsWithChildren) {
  const [integerPrice, decimalPrice] = priceFormatted.split('.');

  const ref = useTrackCTAImpression({
    price,
    product: term,
    title: 'oddschecker_plus',
    wallType: 'Landing Page'
  });

  return (
    <Card
      borderRadius="l"
      className={styles.priceCard}
      variant="secondary"
      {...props}>

			<div className={styles.cardWrapper}>
				<div className={styles.titleWrapper}>
					<h2 className={styles.title}>{title}</h2>
					{subtitle && <h3 className={styles.subtitle}>{subtitle}</h3>}
				</div>
				<List
          className={styles.list}
          direction="column"
          items={list}
          size="s" />

				<span className={styles.priceWrapper}>
					<p className={styles.price} data-testid="price">
						<span className={styles.highlight}>{integerPrice}</span>
						<span>
							{`.${decimalPrice} / ${term === SUBSCRIPTION_TERM.MONTHLY ? 'month' : 'year'}`}
						</span>
					</p>
					<p className={styles.term} data-testid="term">
						Paid {term}
					</p>
				</span>
				<Button
          className={styles.button}
          onClick={onClick}
          ref={ref}
          size="large"
          variant="secondary">

					<span>
						{userHasCancelledSubscription ?
            'Subscribe Now' :
            'Start 7-Day Free Trial'}
					</span>
				</Button>
			</div>
		</Card>);

}